module.exports = __webpack_public_path__ + "img/xeno-5.6170fba5.jpg";